import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { diffText } from '../utils/textDiff';

/**
 * A corrected text shown against its original: removed words struck through,
 * added words highlighted, everything else as it reads. Replaces the old
 * "whole text struck through, whole new text below" preview, where a single
 * fixed comma was impossible to spot.
 */
export default function DiffText({ before, after }) {
  const { t } = useTranslation();
  const segments = useMemo(() => diffText(before || '', after || ''), [before, after]);
  return (
    <div className="diff-text">
      <p className="diff-legend">
        <del className="diff-del">{t('ai.diffRemoved')}</del>
        <ins className="diff-ins">{t('ai.diffAdded')}</ins>
      </p>
      <div className="diff-body">
        {segments.map((s, i) => {
          if (s.type === 'del') return <del key={i} className="diff-del">{s.text}</del>;
          if (s.type === 'ins') return <ins key={i} className="diff-ins">{s.text}</ins>;
          return <span key={i}>{s.text}</span>;
        })}
      </div>
    </div>
  );
}
